import React, { forwardRef, useEffect, useRef, useState } from 'react'
const DesktopNavigationSearchView = forwardRef(
  (
    {
      name,
      action,
      searchText,
      onSearchChange,
      onSearchLeave,
      onKeyUpSearch,
      autoCompleteData,
      autoCompleteIndex,
      onClickAutoCompItem,
    },
    ref
  ) => {
    const searchWrapperRef = useRef()
    const [expend, setExpend] = useState(false)
    const searchInputRef = useRef()

    useEffect(() => {
      if (searchInputRef && expend) {
        searchInputRef.current.focus()
      }
    }, [expend])

    useEffect(() => {
      document.addEventListener('click', documenClicktListener)

      return () => {
        document.removeEventListener('click', documenClicktListener)
      }
    }, [searchWrapperRef])

    const documenClicktListener = (event) => {
      if (
        searchWrapperRef?.current &&
        !searchWrapperRef?.current?.contains(event.target)
      ) {
        setExpend(false)
      }
    }

    const sanitizeInput = (input) => {
      return input.replaceAll('%22', '').replaceAll(' ', '+')
    }

    const handleSubmit = (e) => {
      e.preventDefault()
      window.location = `${action}?search=${sanitizeInput(
        encodeURIComponent(searchText)
      )}`
    }

    return (
      <>
        <div
          ref={searchWrapperRef}
          className={`Navigation-action u-block u-sm-paddingVert3gu u-md-paddingVert3gu u-posRelative`}
          onClick={() => setExpend(true)}
        >
          <form
            className="u-posRelative"
            role="form"
            ref={ref}
            onSubmit={handleSubmit}
          >
            <label className="u-hiddenVisually" htmlFor="cti-navigation-search">
              {name}
            </label>
            <div className="u-flex">
              <div className="u-flex u-flexAuto u-flexCol">
                <div className="nav-search-input-container u-flex u-flexAuto u-flexAlignItemsCenter">
                  <span
                    className="Navigation-topSearchIcon Navigation-icon Icon--before Icons Icon--material"
                    data-icon="&#xE8B6;"
                  ></span>

                  <label htmlFor="search-input">
                    <input
                      id="search-input"
                      ref={searchInputRef}
                      type="text"
                      name="search"
                      className={`Input Input--withIcon Icon--before Navigation-searchField action-transiton ${
                        expend ? 'expended' : 'collapsed'
                      }`}
                      aria-label="Search for products, documents, and more"
                      value={searchText}
                      onChange={onSearchChange}
                      onKeyUp={onKeyUpSearch}
                      autoComplete="off"
                      onBlur={() =>
                        setTimeout(() => {
                          onSearchLeave()
                        }, 500)
                      }
                    />
                  </label>
                </div>
                {autoCompleteData && autoCompleteData.length > 0 && (
                  <div className="u-bgColorWhite u-textColorDefault  u-marginTop1gu search-result">
                    {autoCompleteData.map((item, index) => {
                      return (
                        <div
                          key={item}
                          className={`auto-complete-suggestion u-paddingVert1gu u-paddingHoriz5gu u-textSizeMsr ${
                            index === autoCompleteIndex
                              ? 'u-bgColorBrandLight u-textColorWhite'
                              : ''
                          }`}
                          onClick={() => onClickAutoCompItem(item)}
                        >
                          {item}
                        </div>
                      )
                    })}
                  </div>
                )}
              </div>
              <div>
                <input
                  disabled={expend && searchText?.length === 0}
                  type="submit"
                  className={`Button nav-searchButton u-paddingVert1gu u-textSizeMsrp1 u-paddingHoriz0 u-textBold u-border0 u-bgColorTransparent u-textCapitalize ${
                    expend && searchText?.length > 0
                      ? 'u-textColorBrandLight'
                      : ''
                  } ${!expend ? 'u-textColorBrand' : ''}`}
                  value="Search"
                />
              </div>
            </div>
          </form>
        </div>
      </>
    )
  }
)
DesktopNavigationSearchView.displayName = 'DesktopNavigationSearchView'

export default DesktopNavigationSearchView
